module.exports = __webpack_public_path__ + "img/work-from-home.375d6f25.png";